import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PatientPortalRoutingModule } from './patient-portal-routing.module';

import { PatientPortalComponent } from './patient-portal.component';
import { PatientPortalHomeComponent } from './patient-portal-home/patient-portal-home.component';
import { PatientPortalMyInfoComponent } from './patient-portal-my-info/patient-portal-my-info.component';
import { PatientPortalInsuranceComponent } from './patient-portal-insurance/patient-portal-insurance.component';
import { PatientPortalContactsComponent } from './patient-portal-contacts/patient-portal-contacts.component';
import { PatientPortalFormsComponent } from './patient-portal-forms/patient-portal-forms.component';
import { PatientPortalCheckInComponent } from './patient-portal-check-in/patient-portal-check-in.component';
import { PatientPortalConfirmAppointmentComponent } from './patient-portal-confirm-appointment/patient-portal-confirm-appointment.component';
import { PatientPortalContactMethodComponent } from './patient-portal-contact-method/patient-portal-contact-method.component';
import { PatientPortalRescheduleComponent } from './patient-portal-reschedule/patient-portal-reschedule.component';
import { PatientPortalTreatmentsComponent } from './patient-portal-treatments/patient-portal-treatments.component';


import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsFormModule } from '../forms/forms-form/forms-form.module';
import { FileManagerModule } from '../file-manager/file-manager.module';
import { FileManagerViewModule } from '../file-manager/file-manager-view/file-manager-view.module';
import { PatientPortalPaymentsComponent } from './patient-portal-payments/patient-portal-payments.component';
import { ARModule } from '../ar/ar.module';
import { PatientPortalPlansComponent } from './patient-portal-plans/patient-portal-plans.component';
import { TdoControlsModule } from 'src/app/tdo-controls/tdo-controls.module';
import { PatientPortalRequestAppointmentComponent } from './patient-portal-request-appointment/patient-portal-request-appointment.component';
import { PatientTransactionComponent } from './patient-transaction/patient-transaction.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PatientPortalAppointmentComponent } from './patient-portal-appointment/patient-portal-appointment.component';
import { PatientPortalCorrespondenceComponent } from './patient-portal-correspondence/patient-portal-correspondence.component';
import { CaseFormsModule } from '../case-forms/case-forms.module';
import { ItemFilterPipe } from 'src/app/pipes/item-filter.pipe';
import { PipeModule } from 'src/app/pipes/pipe.module';

@NgModule({
    declarations: [
        PatientPortalComponent,
        PatientPortalHomeComponent,
        PatientPortalMyInfoComponent,
        PatientPortalInsuranceComponent,
        PatientPortalContactsComponent,
        PatientPortalFormsComponent,
        PatientPortalCheckInComponent,
        PatientPortalConfirmAppointmentComponent,
        PatientPortalContactMethodComponent,
        PatientPortalRescheduleComponent,
        PatientPortalPaymentsComponent,
        PatientPortalTreatmentsComponent,
        PatientPortalPlansComponent,
        PatientPortalRequestAppointmentComponent,
        PatientTransactionComponent,
        PatientPortalAppointmentComponent,
        PatientPortalCorrespondenceComponent,
    ],
    imports: [
        CommonModule,
        PatientPortalRoutingModule,
        FormsModule,
        FormsFormModule,
        FileManagerViewModule,
        ARModule,
        FileManagerModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTabsModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatDialogModule,
        MatDividerModule,
        MatSnackBarModule,        
        MatTooltipModule,
        TdoControlsModule,
        CaseFormsModule,
        PipeModule
    ],
    providers: [
      ItemFilterPipe
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PatientPortalModule { }
